import React, { Component, Fragment } from 'react';
import EditCategoryModal from 'modules/budget/components/category/modals/edit-category-modal';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withNamespaces } from 'react-i18next';

@withNamespaces()
class AddRootCategoryButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false,
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.addSuccess = this.addSuccess.bind(this);
    }

    openModal() {
        this.setState({modalOpen: true});
    }

    closeModal() {
        this.setState({modalOpen: false});
    }

    addSuccess(data) {
        this.setState({modalOpen: false}, () => {
            setTimeout(() => {
                const el = document.getElementById('parent-category-' + data.id);
                if (el) {
                    el.scrollIntoView();
                }
            }, 50);
        })
    }

    render() {
        const { t } = this.props;
        const modal = this.state.modalOpen ? <EditCategoryModal onClose={this.closeModal} onSuccess={this.addSuccess} /> : null;

        return (
            <Fragment>
                <button onClick={this.openModal} type="button" className="btn btn-xs btn-default">
                    <FontAwesomeIcon icon={faPlus} fixedWidth={true} />
                    {t('BUDGET.CATEGORY.ADD_ROOT_CATEGORY')}
                </button>
                {modal}
            </Fragment>
        )
    }
}

export default AddRootCategoryButton;



// WEBPACK FOOTER //
// ./src/modules/budget/components/category/category-table/add-root-category-button.js